import { AuditLogOptions } from 'store/audit/types';
import { FiltersFormValues } from '../types/filter';
import { filtersReqDTO, filtersResDTO } from './mappers';

//
//  Function: filterValues
//  Description: Transforms options to shape of filters values
//
export const filterValues = (defaultOptions: AuditLogOptions) => ({
  filters: filtersReqDTO.filters(defaultOptions),
  facets: filtersReqDTO.facets(defaultOptions),
  startsAt: defaultOptions.startsAt,
  endsAt: defaultOptions.endsAt
});

//
//  Function: optionValues
//  Description: Transform filters values to shape of options
//
export const optionValues = (defaultOptions: AuditLogOptions, values: FiltersFormValues) => ({
  ...defaultOptions,
  page: 0,
  filters: filtersResDTO.filters(values),
  facets: filtersResDTO.facets(values),
  startsAt: values.startsAt,
  endsAt: values.endsAt
});
